import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useQuery } from "convex/react"
import { api } from "../../convex/_generated/api"
import type { Id } from "../../convex/_generated/dataModel"
import { MessagesInbox, type InboxThread } from "@/components/messages-inbox"

export const Route = createFileRoute("/candidate/messages")({
  validateSearch: (search: Record<string, unknown>) => ({
    thread:
      typeof search.thread === "string"
        ? (search.thread as Id<"outreachThreads">)
        : undefined,
  }),
  component: CandidateMessagesPage,
})

function CandidateMessagesPage() {
  const { thread } = Route.useSearch()
  const navigate = useNavigate()
  const threads = useQuery(api.outreach.listForSeeker)

  const inboxThreads: InboxThread[] | undefined = threads?.map((t) => ({
    _id: t._id,
    peerName: t.companyName,
    peerSubtitle: t.companyOneLiner,
    peerAvatarUrl: t.companyLogoUrl,
    jobTitle: t.jobTitle,
    jobId: t.jobId,
    companyId: t.companyId,
    lastMessagePreview: t.lastMessagePreview,
    lastMessageAt: t.lastMessageAt,
    unread: t.unread,
  }))

  return (
    <MessagesInbox
      mode="seeker"
      threads={inboxThreads}
      emptyCopy="When a company messages you about a role on Hire, you'll see it here."
      emptyCta={{ label: "Discover jobs", to: "/candidate" }}
      selectedThreadId={thread ?? null}
      onThreadChange={(threadId) => {
        void navigate({
          to: "/candidate/messages",
          search: { thread: threadId ?? undefined },
          replace: true,
        })
      }}
    />
  )
}
